import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../api/admin/users';

/**
 * Resolves a raw users.id (a system account - distinct from an
 * employee_id) to a real display name. Reused everywhere a page
 * currently shows a bare "User #42" or a raw numeric ID for an
 * approver, delegator, reviewer, case owner, etc. - the same fix
 * already applied to Employee IDs via EmployeePicker, here for the
 * User ID half of that same audit.
 *
 * Consolidates a pattern that was being redefined locally in each
 * admin page (Delegations, etc.) into one shared hook.
 */
export function useUserName() {
  const usersQuery = useQuery({ queryKey: ['users'], queryFn: () => usersApi.list() });

  const userName = (id: number | null | undefined): string => {
    if (!id) return '-';
    return usersQuery.data?.data.find((u) => u.id === id)?.full_name ?? `User #${id}`;
  };

  return { userName, users: usersQuery.data?.data ?? [], isLoading: usersQuery.isLoading };
}
